import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityLinksApi } from 'src/Services/API';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

export const linkedEntitiesQueryKey = (
  assetId: string | undefined,
  entityType: LinkableEntityType,
  entityId: string | undefined
) => ['linked-entities', assetId, entityType, entityId] as const;

const useFetchLinkedEntities = (entityType: LinkableEntityType, entityId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: linkedEntitiesQueryKey(assetId, entityType, entityId),
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!entityId) throw new Error('No entityId provided');
      return entityLinksApi.findAll(assetId, entityType, entityId);
    },
    enabled: !!assetId && !!entityId,
    staleTime: 30_000,
  });
};

export default useFetchLinkedEntities;
